import { useState } from 'react'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import { authService } from 'services/auth.services'

import { _object } from 'utils/interfaces'

import { Button, InputField } from 'components/form-inputs'

const SetPassword = () => {
  const [loading, setLoading] = useState(false)
  const validationSchema = Yup.object({
    current_password: Yup.string().label('Current Password').min(4).required(),
    new_password: Yup.string().label('New Password').min(4).required(),
    confirm_password: Yup.string()
      .label('Confirm password')
      .min(4)
      .oneOf([Yup.ref('new_password')], 'Passwords must match')
      .required()
  })
  const formik: any = useFormik({
    initialValues: {
      current_password: '',
      new_password: '',
      confirm_password: ''
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      authService.changePassword(values).then((results: _object) => {
        setLoading(false)
        results?.error === false &&
          results?.formik.resetForm({
            values: { current_password: '', new_password: '', confirm_password: '' }
          })
      })
    }
  })

  return (
    <>
      <form onSubmit={formik.handleSubmit} className="mt-5 space-y-8">
        <div>
          <InputField
            name="current_password"
            type="password"
            placeholder="Current Password"
            onBlur={formik.handleBlur}
            value={formik.values.current_password}
            onChange={formik.handleChange}
            required={true}
            error={formik.touched.current_password && formik.errors.current_password}
          />

          <InputField
            name="new_password"
            type="password"
            placeholder="New Password"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.new_password}
            error={formik.touched.new_password && formik.errors.new_password}
            required={true}
          />
          <InputField
            name="confirm_password"
            type="password"
            placeholder="Confirm Password"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.confirm_password}
            error={formik.touched.confirm_password && formik.errors.confirm_password}
            required={true}
          />
        </div>

        <Button
          label="Save Changes"
          type="submit"
          className="w-full rounded-md"
          loading={loading}
          disabled={!formik.isValid || !formik.dirty}
        />
      </form>
    </>
  )
}
export default SetPassword
